import "core-js/modules/es.array.find-index.js";
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "jiao-interact"
};
var _hoisted_2 = {
  class: "jiao-interact-content"
};
import { computed, ref } from 'vue';
import SubTab from '../../Components/SubTab.vue';
import Resource from './Resource.vue';
import Show from './Show.vue';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var tabs = [{
      name: '推送资源',
      value: 1,
      component: Resource,
      exist: true
    }, {
      name: '课堂展示',
      value: 2,
      component: Show,
      exist: true
    }];
    var defaultIndex = ref(2);
    var currentComponent = computed(function () {
      var index = tabs.findIndex(function (item) {
        return item.value === defaultIndex.value;
      });
      return tabs[index].component;
    });
    var handleChangeTab = function handleChangeTab(item) {
      defaultIndex.value = item.value;
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value)))])]);
    };
  }
};